export class WinPresentationEvents {
	public static readonly INITIAL_ANIMATION_STARTED: string = 'WinPresentationEvents::__INITIAL_ANIMATION_STARTED__';
	public static readonly INDIVIDUAL_ANIMATION_STARTED: string = 'WinPresentationEvents::__INDIVIDUAL_ANIMATION_STARTED__';
	public static readonly INITIAL_ANIMATION_FINISHED: string = 'WinPresentationEvents::__INITIAL_ANIMATION_FINISHED__';
	public static readonly INITIAL_ANIMATION_SKIPPED: string = 'WinPresentationEvents::__INITIAL_ANIMATION_SKIPPED__';
	public static readonly INDIVIDUAL_ANIMATION_SKIPPED: string = 'WinPresentationEvents::__INDIVIDUAL_ANIMATION_SKIPPED__';
	public static readonly INDIVIDUAL_ANIMATION_FINISHED: string = 'WinPresentationEvents::__INDIVIDUAL_ANIMATION_FINISHED__';

	public static readonly COUNTUP_STARTED: string = 'WinPresentationEvents::COUNTUP_STARTED';
	public static readonly COUNTUP_FINISHED: string = 'WinPresentationEvents::COUNTUP_FINISHED';
	public static readonly WIN_NUMBER_SHOWN_TO_PLAYER: string = 'WinPresentationEvents::WIN_NUMBER_SHOWN_TO_PLAYER';
	public static readonly WIN_NUMBER_BOUNCE_FINISHED: string = 'WinPresentationEvents::WIN_NUMBER_BOUNCE_FINISHED';
	public static readonly INITIAL_WIN_ANIMATION_FINISHED: string = 'WinPresentationEvents::INITIAL_WIN_ANIMATION_FINISHED';

	public static readonly WIN_ANIMATION_FOR_SYMBOL_STARTED: string = 'WinPresentationEvents::__WIN_ANIMATION_FOR_SYMBOL_STARTED__';
	public static readonly PLAYING_INDIVIDUAL_WIN_FOR_LINE: string = 'WinPresentationEvents::__PLAYING_INDIVIDUAL_WIN_FOR_LINE__';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents.ts